import React from 'react';
import cx from 'classnames';
import { Badge, Row, Col } from 'antd';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { notEmpty } from 'utils/ramdaAdditions';
import { DateRangeField } from 'components/common/fields/DateTimeFields';

const EducationStages = ({ stages = [] }) => notEmpty(stages) ? (
    <div>
        <DefinitionHeader translate="education.action.stages" iconType="list-ul" />
        <div className="panel-view">
            {stages.map((stage, index) => (
                <Row key={index} className="m-b-15">
                    <Col span={1}>
                        { stage.active && <Badge status="processing" /> }
                    </Col>
                    <Col span={12}>
                        <div className={cx({'p-l-15': stage.parent || stage.parentId})}>
                            { stage.name }
                        </div>
                    </Col>
                    <Col span={11} className="text-right">
                        <DateRangeField date={stage.date} />
                    </Col>
                </Row>
            ))}
        </div>
    </div>
) : null;

export default EducationStages;
